import * as Yup from 'yup';
import { validationMessages } from '../messages/messages';

export const NameSchema = Yup.object().shape({
    name: Yup.string().required(validationMessages.required),
  });